// Native
import { useState } from "react"
import { Badge, Button, ButtonGroup, DialogBody, DialogFooter, Stack, Text } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"

// Custom
import { UI } from "components"
import { API, toaster } from "config"
import useOrder from "hooks/useOrder"

export default function Cancel({ data, ...props }){

    const order = useOrder(data?.id)
    const queryClient = useQueryClient()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/orders/${data?.id}/cancel`)
            toaster.create({ title: `O pedido #${data?.cod} foi cancelado.`, type: 'success' })
            order.refetch()
            queryClient.invalidateQueries('orders')
            queryClient.invalidateQueries('adhesion')
            props.onClose()
        }catch(err){
            toaster.create({ title: 'Não foi possível cancelar o pedido.', description: err?.response?.data?.message, type: 'warning' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog title="Cancelar pedido" size="xs" loading={loading} {...props}>
        <DialogBody>

            <UI.Show visible={order.data?.type === 1}>
                <Stack>
                    <Text>Tem certeza que deseja cancelar o pedido? Ao realizar esta ação, os pagamentos já processados serão devolvidos.</Text>
                    <UI.Alert size="sm" colorPalette="gray">Apenas pedidos com o status <Badge colorPalette="orange">Em análise</Badge> podem ser cancelados.</UI.Alert>
                </Stack>
            </UI.Show>

            <UI.Show visible={order.data?.type === 3}>
                <Stack>
                    <Text>Tem certeza que deseja cancelar o pedido? Ao realizar esta ação, você precisará realizar um novo pedido de adesão.</Text>
                    <UI.Alert size="sm" colorPalette="gray">Apenas pedidos com o status <Badge colorPalette="orange">Em análise</Badge> podem ser cancelados.</UI.Alert>
                </Stack>
            </UI.Show>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup size="sm">
                <Button variant="ghost" colorPalette="red" onClick={handleSubmit} loading={loading} loadingText="Cancelando pedido..."><UI.Icon name="cancel" /> Sim, desejo cancelar</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )
}